import { useQuery } from '@tanstack/react-query';
import { usersApi } from '@/features/dashboard/users/api/usersApi.ts';
import { usersApiQueryKeys } from '@/features/dashboard/users/api/usersApi.queryKeys.ts';

const useGetUserByEmail = (email?: string) => {
  return useQuery({
    queryKey: usersApiQueryKeys.byEmail(email!),
    queryFn: () => usersApi.getByEmail(email!),
    enabled: !!email,
  });
};

export default useGetUserByEmail;
